(function(){
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- NAV --- */
  var burger = document.getElementById('burger');
  var headerNav = document.getElementById('header-nav');
  if(burger && headerNav){
    burger.addEventListener('click', function(){
      headerNav.classList.toggle('open');
      burger.setAttribute('aria-expanded', headerNav.classList.contains('open'));
    });
  }

  /* --- SEARCH PANEL --- */
  var searchToggle = document.getElementById('search-toggle');
  var searchPanel = document.getElementById('search-panel');
  if(searchToggle && searchPanel){
    searchToggle.addEventListener('click', function(){
      var hidden = searchPanel.hasAttribute('hidden');
      if(hidden){ searchPanel.removeAttribute('hidden'); searchPanel.querySelector('input').focus(); }
      else { searchPanel.setAttribute('hidden',''); }
    });
  }

  /* --- SCROLL REVEALS --- */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }});
  },{threshold:0.18});
  document.querySelectorAll('.md-reveal, .md-mask, .md-inter, .md-fframe').forEach(function(el){ io.observe(el); });

  /* --- COUNT UP --- */
  var io2 = new IntersectionObserver(function(es){
    es.forEach(function(en){
      if(en.isIntersecting){
        var el=en.target, t=+el.dataset.count, sfx=el.dataset.suffix||'';
        var s=performance.now();
        (function cu(n){ var p=Math.min((n-s)/1300,1); el.textContent=Math.round(p*t)+sfx; if(p<1)requestAnimationFrame(cu); })(s);
        io2.unobserve(el);
      }
    });
  },{threshold:0.6});
  document.querySelectorAll('[data-count]').forEach(function(el){ io2.observe(el); });

  /* --- INDEX DISC CURSOR --- */
  var disc = document.getElementById('md-disc');
  if(!disc){ var disc = document.createElement('div'); disc.id='md-disc'; disc.textContent='View'; document.body.appendChild(disc); }
  var discOver = false;
  document.addEventListener('mousemove', function(e){ if(discOver){ disc.style.left=e.clientX+'px'; disc.style.top=e.clientY+'px'; }});
  document.querySelectorAll('.md-row').forEach(function(r){
    r.addEventListener('mouseenter', function(){ discOver=true; disc.classList.add('on'); });
    r.addEventListener('mouseleave', function(){ discOver=false; disc.classList.remove('on'); });
  });

  /* --- MAGNETIC BUTTONS --- */
  if(!reduce){
    document.querySelectorAll('.md-mag').forEach(function(m){
      m.addEventListener('mousemove', function(e){ var r=m.getBoundingClientRect(); m.style.transform='translate('+((e.clientX-r.left-r.width/2)*0.3)+'px,'+((e.clientY-r.top-r.height/2)*0.4)+'px)'; });
      m.addEventListener('mouseleave', function(){ m.style.transform=''; });
    });
  }

  /* --- PRODUCT THUMBNAILS --- */
  var mainImg = document.getElementById('main-product-img');
  if(mainImg){
    document.querySelectorAll('.prod-thumb').forEach(function(t){
      t.addEventListener('click', function(){
        mainImg.src = t.dataset.src;
        document.querySelectorAll('.prod-thumb').forEach(function(x){ x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
  }

  /* --- VARIANT SELECTOR --- */
  var variantId = document.getElementById('variant-id');
  if(variantId){
    document.querySelectorAll('.prod-option-values input').forEach(function(inp){
      inp.addEventListener('change', function(){
        // Shopify variant selection — basic implementation
        // For full variant logic, Shopify's native variant JS or a plugin handles this
        console.log('Variant option changed:', inp.name, inp.value);
      });
    });
  }

  /* --- CART DRAWER --- */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartToggle = document.getElementById('cart-toggle');
  var cartClose = cartDrawer ? cartDrawer.querySelector('.cart-drawer__close') : null;
  var cartOverlay = cartDrawer ? cartDrawer.querySelector('.cart-drawer__overlay') : null;

  function openCart(){
    if(!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCart(){
    if(!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }
  if(cartToggle) cartToggle.addEventListener('click', openCart);
  if(cartClose) cartClose.addEventListener('click', closeCart);
  if(cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function fetchCart(){
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var countEl = document.getElementById('cart-count');
        if(countEl) countEl.textContent = cart.item_count;
        var totalEl = document.getElementById('cart-total');
        if(totalEl) totalEl.textContent = '\u20B9' + (cart.total_price/100).toFixed(0);
        var body = document.getElementById('cart-items');
        if(!body) return;
        if(cart.items.length === 0){
          body.innerHTML = '<p class="cart-empty">Your cart is empty.</p>'; return;
        }
        var html = cart.items.map(function(item){
          return '<div class="cart-drawer-item" style="display:grid;grid-template-columns:80px 1fr;gap:16px;padding:16px 0;border-bottom:1px solid var(--navy-08)">'
            +'<img src="'+item.image+'" alt="'+item.title+'" style="width:80px;height:100px;object-fit:cover;border:1px solid var(--navy-08)">'
            +'<div><p style="font-family:DM Serif Display,serif;font-size:16px;color:var(--navy);margin-bottom:6px">'+item.product_title+'</p>'
            +(item.variant_title !== 'Default Title' ? '<p style="font-size:11px;letter-spacing:0.12em;color:var(--navy-45);margin-bottom:12px">'+item.variant_title+'</p>' : '')
            +'<p style="font-family:Source Serif 4,serif;font-size:15px;color:var(--navy)">\u20B9'+(item.line_price/100).toFixed(0)+'</p></div></div>';
        }).join('');
        body.innerHTML = html;
      }).catch(function(e){ console.error('Cart fetch error',e); });
  }

  /* --- ADD TO CART --- */
  var atcBtn = document.getElementById('add-to-cart');
  var prodForm = document.getElementById('product-form');
  if(atcBtn && prodForm){
    prodForm.addEventListener('submit', function(e){
      e.preventDefault();
      var varId = document.getElementById('variant-id');
      if(!varId) return;
      atcBtn.textContent = 'Adding...';
      atcBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({id: varId.value, quantity: 1})
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        atcBtn.textContent = 'Added!';
        setTimeout(function(){ atcBtn.textContent = 'Add to Cart'; atcBtn.disabled = false; }, 1600);
        openCart();
      })
      .catch(function(err){
        console.error(err);
        atcBtn.textContent = 'Try Again';
        atcBtn.disabled = false;
      });
    });
  }

})();
